module.exports = __webpack_public_path__ + "static/img/menu_fold.08feccff.svg";